export const NIBUTCOLORS = [
  "#ff0000",
  "#ff2000",
  "#ff4000",
  "#ff6000",
  "#ff8000",
  "#ffa000",
  "#ffc000",
  "#ffff00",
  "#dfff00",
  "#bfff00",
  "#bfff00",
  "#9fff00",
  "#7fff00",
  "#5fff00",
  "transparent"
];
export const LIPIDLEVELS = [
  {
    level: 1,
    threshold: 15,
    color: "#e43d45"
  },
  {
    level: 2,
    threshold: 15,
    color: "#dd696f"
  },
  {
    level: 3,
    threshold: 15,
    color: "#f5a963"
  },
  {
    level: 4,
    threshold: 15,
    color: "#b5e07b"
  }
];
export const SELECTOPTION = {
  ZN_options: [
    {
      value: "0",
      label: "眼表面疾患指数©(OSDI©)2"
    },
    {
      value: "1",
      label: "干眼问卷调查表"
    }
  ],
  EN_options: [
    {
      value: "0",
      label: "DEQ 5"
    },
    {
      value: "1",
      label: "SPEED™ QUESTIONNAIRE"
    },
    {
      value: "2",
      label: "Ocular Surface Disease Index©(OSDI©)2"
    },
    {
      value: "3",
      label: "McMonnies Dry Eye Questionnaire"
    }
  ],
  JA_options: [
    {
      value: "0",
      label: "McMonniesドライアイアンケート"
    },
    {
      value: "1",
      label: "SPEED™アンケート"
    },
    {
      value: "2",
      label: "眼表面疾患指数©(OSDI©)2"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/dryeye/js/consts.js